import {getIsKilnConfigValid} from '@hconnect/kilnfeature/src/helpers/getIsKilnConfigValid'
import {useUpmPlant} from '@hconnect/upm'

import {useKilns} from '@refra/modules/common/providers'
import {useKilnConfig} from '@refra/modules/refra-planning/hooks/queries'
import {useUrlParam} from '@refra/modules/routing/hooks'

export const useValidateKilnConfig = () => {
  const plantId = useUrlParam('plantCode')
  const upmPlant = useUpmPlant({plantId})
  const {selectedKiln} = useKilns()

  const {
    data: kilnConfig,
    isLoading: isKilnConfigLoading,
    error: kilnConfigError
  } = useKilnConfig({
    plantUpmId: upmPlant.upmId,
    kilnUpmId: selectedKiln.upmId
  })

  const isKilngConfigValid =
    !!kilnConfig &&
    kilnConfigError?.response?.status !== 404 &&
    getIsKilnConfigValid(kilnConfig.payload.layout, kilnConfig.payload.configuration)
      .isKilnConfigValid

  return {isKilngConfigValid, isKilnConfigLoading}
}
